/*
 * @author bai <ghimping@alpstein.my>
 * @link https://www.alpstein.my
 * @copyright Copyright (c) Alpstein Software
 *            _____                    _____                    _____
 *           /\    \                  /\    \                  /\    \
 *          /::\    \                /::\    \                /::\    \
 *         /::::\    \              /::::\    \               \:::\    \
 *        /::::::\    \            /::::::\    \               \:::\    \
 *       /:::/\:::\    \          /:::/\:::\    \               \:::\    \
 *      /:::/__\:::\    \        /:::/__\:::\    \               \:::\    \
 *     /::::\   \:::\    \      /::::\   \:::\    \              /::::\    \
 *    /::::::\   \:::\    \    /::::::\   \:::\    \    ____    /::::::\    \
 *   /:::/\:::\   \:::\ ___\  /:::/\:::\   \:::\    \  /\   \  /:::/\:::\    \
 *  /:::/__\:::\   \:::|    |/:::/  \:::\   \:::\____\/::\   \/:::/  \:::\____\
 *  \:::\   \:::\  /:::|____|\::/    \:::\  /:::/    /\:::\  /:::/    \::/    /
 *   \:::\   \:::\/:::/    /  \/____/ \:::\/:::/    /  \:::\/:::/    / \/____/
 *    \:::\   \::::::/    /            \::::::/    /    \::::::/    /
 *     \:::\   \::::/    /              \::::/    /      \::::/____/
 *      \:::\  /:::/    /               /:::/    /        \:::\    \
 *       \:::\/:::/    /               /:::/    /          \:::\    \
 *        \::::::/    /               /:::/    /            \:::\    \
 *         \::::/    /               /:::/    /              \:::\____\
 *          \::/____/                \::/    /                \::/    /
 *           ~~                       \/____/                  \/____/
 *
 */

import React, { Component } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { Button, WhiteSpace } from "antd-mobile";
import { FormattedMessage, injectIntl } from "react-intl";
import Theme from "../../../utils/Theme";
import logo from "../../../assets/logo-square-transparent.png";
import TextInput from "../../../components/TextInput";
import * as selectors from "../../../selectors";
import { connect } from "react-redux";

const StyledContainer = styled.div`
  width: 100%;
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  text-align: center;
`;

const StyledLogoContainer = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
`;

const StyledLogo = styled.img`
  width: 60%;
`;

const StyledDescription = styled.span`
  margin-top: 3%;
  color: grey;
  font-size: 0.9em;
  line-height: 1.3em;
`;

const StyledButton = styled(Button)`
  margin-top: 10%;
  width: 100%;
  box-shadow: 0 4px 6px -5px grey;
  && {
    cursor: pointer;
    font-size: 1em
    border-radius: 25px;
    color: white;
    background-color: ${props =>
      props.disabled ? "grey" : Theme.PrimaryColor};
  }
`;

class EnterPhoneNumSection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mobile_number: {
        value: "",
        error: false,
        error_message: ""
      }
    };
  }

  onMobileSubmit = () => {
    const { mobile_number } = this.state;
    const { onMobileSubmit } = this.props;
    onMobileSubmit && onMobileSubmit(mobile_number);
  };

  onMobileNumberChange = txt => {
    this.setState({
      mobile_number: {
        value: txt,
        error: false,
        error_message: ""
      }
    });
  };

  render() {
    const { mobile_number } = this.state;
    const { requestLoading, error } = this.props;

    return (
      <StyledContainer>
        <WhiteSpace size={"xl"} />
        <WhiteSpace size={"xl"} />
        <StyledLogoContainer>
          <StyledLogo src={logo} alt="lsquare-logo" />
        </StyledLogoContainer>
        <StyledDescription>
          <FormattedMessage
            id="register.description"
            defaultMessage="Create your own account to top up your credits to the wallets & enjoy other benefits too!"
            description="Signup Description"
          />
        </StyledDescription>
        <WhiteSpace size={"lg"} />
        <TextInput
          style={{ alignSelf: "stretch", marginTop: "8%" }}
          type={"mobile"}
          error={error}
          disabled={requestLoading}
          onChange={txt => this.onMobileNumberChange(txt)}
        />
        <StyledButton
          disabled={requestLoading || mobile_number.value.length < 10}
          loading={requestLoading}
          activeStyle={{ backgroundColor: Theme.ActivePrimary }}
          onClick={this.onMobileSubmit}
        >
          {requestLoading ? (
            <FormattedMessage
              id="app.loading"
              defaultMessage="Loading"
              description="Loading Title"
            />
          ) : (
            <FormattedMessage
              id="register.next.btn"
              defaultMessage="NEXT >"
              description="Register Page Next Btn Title"
            />
          )}
        </StyledButton>
      </StyledContainer>
    );
  }
}

EnterPhoneNumSection.propTypes = {
  intl: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  error: PropTypes.object.isRequired,
  requestLoading: PropTypes.bool,
  onMobileSubmit: PropTypes.func.isRequired
};

function mapStateToProps(state) {
  return {
    requestLoading: selectors.getRequestPhoneVerificationLoading(state)
  };
}

export default injectIntl(connect(mapStateToProps)(EnterPhoneNumSection));



// WEBPACK FOOTER //
// ./src/containers/RegisterPage/EnterPhoneNumSection/index.js